import { render } from "./equally.vue?vue&type=template&id=02968618&scoped=true"
import script from "./equally.vue?vue&type=script&lang=js"
export * from "./equally.vue?vue&type=script&lang=js"

import "./equally.vue?vue&type=style&index=0&id=02968618&scoped=true&lang=css"

import exportComponent from "/Users/qiao/KaungSpace/DevSpace/KaungAdmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02968618"]])

export default __exports__